var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("queryJob.WarehousingInstructions"),
        width: "500px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            { attrs: { "label-width": "110px", "label-position": "left" } },
            [
              _c("el-form-item", { attrs: { label: "" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "1" },
                        model: {
                          value: _vm.form.ownWarehouse,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ownWarehouse", $$v)
                          },
                          expression: "form.ownWarehouse"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("queryJob.GoodsIntoThisWarehouse"))
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "2" },
                        model: {
                          value: _vm.form.takePhotos,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "takePhotos", $$v)
                          },
                          expression: "form.takePhotos"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("queryJob.NeedPhotos")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "3" },
                        model: {
                          value: _vm.form.documentsAttached,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "documentsAttached", $$v)
                          },
                          expression: "form.documentsAttached"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("queryJob.AttachedDocuments")))]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("queryJob.warehouseNo") + "：" } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "4",
                          type: "textarea",
                          rows: 5,
                          size: "min"
                        },
                        model: {
                          value: _vm.form.warehouseNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "warehouseNo", $$v)
                          },
                          expression: "form.warehouseNo"
                        }
                      }),
                      _c(
                        "div",
                        { staticStyle: { "margin-left": "5px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "5",
                                type: "primary",
                                disabled: _vm.btnGenerateEnable
                              },
                              on: { click: _vm.generateHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("queryJob.Generate")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: {
                    label:
                      _vm.$t("CargoMsg.Cargo_EstimatedWarehousingTime") + "："
                  }
                },
                [
                  _c("cargo-date-time-field-input", {
                    staticStyle: { "margin-left": "-10px" },
                    model: {
                      value: _vm.form.estimatedDateOfWarehousinge,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "estimatedDateOfWarehousinge", $$v)
                      },
                      expression: "form.estimatedDateOfWarehousinge"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("queryJob.OtherInstructions") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "6",
                          type: "textarea",
                          rows: 5,
                          size: "min"
                        },
                        model: {
                          value: _vm.form.otherWarehouseNotes,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "otherWarehouseNotes", $$v)
                          },
                          expression: "form.otherWarehouseNotes"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "7", type: "primary" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            { attrs: { no: "8" }, on: { click: _vm.cancelHandler } },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }